
<router-outlet />
<careposi-loading></careposi-loading>
